import Text from '@sats-group/ui-lib/react/text';
import clsx from 'clsx';
import React from 'react';
import type { Logo as Props } from './logo.types';

export const Logo: React.FC<Props> = ({
  elementName,
  inline,
  small,
  variant,
}) =>
  React.createElement(
    elementName,
    {
      className: clsx('logo', `logo--${variant}`, {
        'logo--inline': inline,
      }),
    },
    <Text
      elementName="span"
      italic
      size={small ? Text.sizes.headline3 : Text.sizes.headline2}
      theme={Text.themes.headline}
    >
      SATS
    </Text>,
    inline ? (
      <Text
        elementName="span"
        italic
        size={small ? Text.sizes.headline3 : Text.sizes.headline2}
        theme={Text.themes.headline}
      >
        {' '}
      </Text>
    ) : null,
    <Text
      elementName="span"
      italic
      size={small ? Text.sizes.headline3 : Text.sizes.headline2}
      theme={Text.themes.headline}
    >
      CORPORATE
    </Text>
  );
